import {
  ICategoryPurposeDataModel,
  ILandholderConfirmationModel,
  ILandholderDetailsModel,
  ILotPlanModel,
  IPurposeDataModel,
  IActivityStorageDataModel,
  INotificationAreaModel,
  ISelfAuditDataModel,
  IExchangeAreaDataModel,
  IRegionalEcosystemSearchResultsModel,
  IDeclarationsDataModel,
  IAcknowledgementNotificationDataModel,
  IRegionalEcosystemStatusModel,
  IAcknowledgementsDataModel,
  IReasonModel,
  INotifierDetailsModel,
  IChannelDimensionsModel,
  IRegionalEcosystemDataModel
} from "./veg-wizard-models";

/** This interface defines all data stored across the form's wizard steps.  */
export interface IFormWizardDataModel {
  landholderConfirmation: ILandholderConfirmationModel | undefined;
  landholderDetails: ILandholderDetailsModel | undefined;
  notifierDetails: INotifierDetailsModel | undefined;
  lotPlan: ILotPlanModel | undefined;
  purpose: IPurposeDataModel | undefined;
  categoryPurposes: ICategoryPurposeDataModel[] | undefined;
  activities: IActivityStorageDataModel | undefined;
  isSelfAuditRequired: boolean;
  selfAuditData: ISelfAuditDataModel | undefined;
  exchangeAreaData: IExchangeAreaDataModel | undefined;
  declarationsData: IDeclarationsDataModel | undefined;
  isCoastalResponse: boolean;
  isExchangeAreaRequired: boolean;
  regionalEcosystemStatus: IRegionalEcosystemStatusModel | undefined;
  regionalEcosystem: IRegionalEcosystemDataModel | undefined;
  notificationArea: INotificationAreaModel | undefined;
  regionalEcosystemSearchResults: IRegionalEcosystemSearchResultsModel | undefined;
  acknowledgementNotificationData: IAcknowledgementNotificationDataModel | undefined;
  acknowledgementsData: IAcknowledgementsDataModel | undefined;
  reasonData: IReasonModel[] | undefined;
  channelDimensions: IChannelDimensionsModel | undefined;
}

export class FormWizardDataModel implements IFormWizardDataModel {
  lotPlan = undefined;
  landholderConfirmation = undefined;
  landholderDetails = undefined;
  notifierDetails = undefined;
  purpose = undefined;
  isSelfAuditRequired = false;
  categoryPurposes = [] as ICategoryPurposeDataModel[];
  activities = undefined;
  isCoastalResponse = false;
  isExchangeAreaRequired = false;
  regionalEcosystemStatus = undefined;
  regionalEcosystem = undefined;
  selfAuditData = undefined;
  exchangeAreaData = undefined;
  channelDimensions = undefined;
  declarationsData = undefined;
  notificationArea = undefined;
  acknowledgementConfirmation = undefined;
  regionalEcosystemSearchResults = undefined;
  acknowledgementNotificationData = undefined;
  acknowledgementsData = undefined;
  reasonData = undefined;
}

export interface IWizardDataState {
  isLotPlanPopulated: boolean;
  isLandHolderConfirmationPopulated: boolean;
  isLandHolderDetailsPopulated: boolean;
  isNotifierDetailsPopulated: boolean;
  isPurposePopulated: boolean;
  isCategoryPurposePopulated: boolean;
  isActivityPopulated: boolean;
  isSelfAuditPopulated: boolean;
  isExchangeAreaPopulated: boolean;
  isRegionalEcosystemPopulated: boolean;
  isRegionalEcosystemStatusPopulated: boolean;
  isCoastalResponsePopulated: boolean;
  isChannelDimensionsPopulated: boolean;
  isNotificationAreaPopulated: boolean;
  isReasonPopulated: boolean;
  isAcknowledgementPopulated: boolean;
  isDeclarationPopulated: boolean;
}

export interface IRouteProperties {
  isVisible: boolean;
  isEnabled: boolean;
}
export interface IRouteState extends IRouteProperties {
  name: string;
  route: string;
  isActive: boolean;
}
export class RouteState implements IRouteState {
  name: string;
  route: string;
  isVisible: boolean;
  isEnabled: boolean;
  isActive: boolean;

  constructor(route: string, name: string) {
    this.name = name;
    this.route = route;
    this.isVisible = false;
    this.isEnabled = false;
    this.isActive = false;
  }
}
